import { Injectable, EventEmitter } from '@angular/core';
import { IAssessmentCategory, IAssessment } from '../../_models';
import { Observable } from 'rxjs';
import { CCECategory } from '../../_models/academic/grading-assessment/cce-category.interface';
import { CCESubCategory } from '../../_models/academic/grading-assessment/cce-sub-category.interface';
import { Assessment } from 'src/app/_models/academic/grading-assessment/assessment.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AssessmentService {
  url = `${environment.apiUrl}`;

  data: IAssessmentCategory[] = [];

  constructor(private http: HttpClient) {


    // this.getAssessments().subscribe((value: IAssessmentCategory[]) => {
    //   this.data = value;
    // });

    //this.data.push({id:1,name:"الامتحانات",nameEn:"Exam",weight:0,percentage:0.00})
    //this.data.push({id:2,name:"الواجبات",nameEn:"Homework",weight:0,percentage:0.00})
    //this.data.push({id:3,name:"المشاريع",nameEn:"Projects",weight:0,percentage:0.00})
    //this.data.push({id:4,name:"الامتحان النصفي",nameEn:"Mid term",weight:0,percentage:0.00})
    //this.data.push({id:5,name:"الامتحانات النهائيه",nameEn:"Final Exam",weight:0,percentage:0.00})


  }
  public ChangeNotefier = new EventEmitter();

  getallAssessmentCategories() {

    return this.http.get(`${this.url}AssessmentAndGrades/GetAllAssessmentCategories`);
    // return this.data;
  }

  getallToAny(): any[] {
    let list: any[] = [];
    this.data.forEach(value => {
      if (!value.weight) value.weight = 0;
      if (!value.percentage) value.percentage = 0.00;
      list.push({ categoryId: value.assessmentCategoryId, categoryName: value.name, categoryNameEn: value.nameEn, weight: value.weight, percentage: value.percentage })
    })
    return list;
  }
  getById(assessmentCategoryId: number): IAssessmentCategory {

    return this.data.find(f => f.assessmentCategoryId === assessmentCategoryId);
  }

  count(): number {
    if (this.data)
      return this.data.length;
    else
      return 0;
  }

  countsub(): number {
    let sum = 0;
    this.data.forEach(value => {
      if (value.assessments) sum += value.assessments.length;
    })
    return sum;
  }

  insertCategory(item: IAssessmentCategory) {
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removeCategory(item: IAssessmentCategory) {
    const i = this.data.findIndex(f => f.assessmentCategoryId === item.assessmentCategoryId);
    if (i > -1) {
      this.data.splice(i, 1);
      this.ChangeNotefier.emit(this.data);
    }
  }

  updateCategory(id: number, item: IAssessmentCategory) {
    const i = this.data.findIndex(f => f.assessmentCategoryId === id);
    if (i > -1) {
      this.data[i] = JSON.parse(JSON.stringify(item));
      this.ChangeNotefier.emit(this.data);
    }
  }

  updateSubCategory(id: number, subId: number, item: IAssessmentCategory) {
    const i = this.data.findIndex(f => f.assessmentCategoryId === id);
    if (i > -1) {

      const j = this.data[i].assessments.findIndex(f => f.assessmentId === subId);

      if (j > -1) {
        this.data[i].assessments[j] = JSON.parse(JSON.stringify(item));
        this.ChangeNotefier.emit(this.data);
      }

    }
  }

  // Create Assessment
  createAssessment(assessmentModel) {
    return this.http.post(`${this.url}AssessmentAndGrades/CreateAssessment`, assessmentModel);
  }

  uploadFile(assessmentFile) {
    return this.http.post(`${this.url}AssessmentAndGrades/UploadAssessAttachment`, assessmentFile);
  }

  downloadFile(fileName) {
    // return this.http.post(`${this.url}File/CreateAssessment`, assessmentModel);
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream',
      'Accept': 'application/octet-stream',
    });
    return this.http.get(`${this.url}File/Download/${fileName}`, { headers: headers, responseType: 'blob' });
  }

  getAssessments(sectionSubjectId: number = null): Observable<IAssessmentCategory[]> {
    return this.http
      .get<IAssessmentCategory[]>(`${this.url}AssessmentAndGrades/GetCategoriesWithAssessments/${sectionSubjectId ? sectionSubjectId : ''}`);
  }


  getAllAssessmentWithSectionSubjects(): Observable<IAssessment[]> {
    return this.http.get<IAssessment[]>(`${this.url}/AssessmentAndGrades/GetAllAssessmentWithSectionSubjects`);
  }

  getBySectionSubjectId(sectionSubjectId: number): Observable<IAssessment[]> {
    return this.http.get<IAssessment[]>(`${this.url}/AssessmentAndGrades/GetBySectionSubjectId/${sectionSubjectId}`);
  }

  // Create Assessment
  updateAssessment(assessmentModel) {
    return this.http.put(`${this.url}AssessmentAndGrades/UpdateAssessment`, assessmentModel);
  }

  removeAssessment(assessmentId) {
    return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAssessment/` + assessmentId);
  }
  // add auditor
  addAuditor(data) {
    return this.http.post(`${this.url}AssessmentAndGrades/AddAuditor`, data);
  }

  // update auditor

  updateAuditor(data) {
    return this.http.put(`${this.url}AssessmentAndGrades/UpdateAuditor`, data);
  }

  // get auditors
  getAuditors(pageIndex: number, pageSize: number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAuditorBySchoolId/${pageIndex}/${pageSize}`);
  }

  // delete auditor
  deleteAuditor(auditorId) {
    return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAuditor/${auditorId}`);
  }

  GetHonorSettings(typeIds: number[]) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetHonorSettings?${this.toHonorSettingQueryString(typeIds)}`)

  }

  SaveAssignedHonorSettings(assignedSettingObj: any) {
    return this.http.post(`${this.url}AssessmentAndGrades/SaveAssignedHonorSettings/`, assignedSettingObj)
  }

  // get auditors by filter 
  getAuditorsByFilter(pageIndex: number, pageSize: number, classId?: number, sectionId?: number, sectionSubjectId?: number) {
    let c = classId != null || classId != undefined ? classId : '';
    let s = sectionId != null || sectionId != undefined ? sectionId : '';
    let sb = sectionSubjectId != null || sectionSubjectId != undefined ? sectionSubjectId : '';
    return this.http.get(`${this.url}AssessmentAndGrades/GetAuditorByFilter?pageIndex=${pageIndex}&pageSize=${pageSize}&classId=${c}&sectionId=${s}&sectionSubjectId=${sb}`);
  }

  // add auditor Subject 
  addAuditorSubject(data) {
    return this.http.post(`${this.url}AssessmentAndGrades/AddAuditorSubject`, data);
  }
  // get Auditor Subject By Auditor Id
  getAuditorSubjectsByAuditorId(auditorId: number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAuditorSubjectsByAuditorId/${auditorId}`);
  }

  // delete auditor subject by auditorSubject Id
  deleteAuditorSubjectById(auditorSubjectId: number) {
    return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAuditorSubject/${auditorSubjectId}`);
  }

  // get assessment by id 

  getAssessmentById(assessmentId: number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAssessmentById/${assessmentId}`);
  }
  private toHonorSettingQueryString(typeIds: number[]) {
    const queryResult = [];

    for (let typeId of typeIds)
      queryResult.push(`typeIds=${typeId}`);

    return queryResult.join('&');
  }

  GetAssessmentCategoriesLookup(setionSubjectId:number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAssessmentCategoriesLookup/` + setionSubjectId);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CCECategoryService {
  url = `${environment.apiUrl}`;
  data: CCECategory[] = [];

  constructor(private http: HttpClient) { }
  public ChangeNotefier = new EventEmitter();


  insertCCECategory(item: CCECategory) {
    return this.http.post(`${this.url}AssessmentAndGrades/CreateAssessmentCCECategory/`, item);
  }
  getCceCategories(assessmentId: number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAllCceCategories/` + assessmentId);
  }



  updateCceCategory(item: CCECategory) {
    return this.http.put(`${this.url}AssessmentAndGrades/UpdateAssessmentCCECategory`, item);
  }
  removeCceCategory(cceCategoryId) {
    return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAssessmentCCECategory/` + cceCategoryId);
  }

}



@Injectable({
  providedIn: 'root'
})
export class CCESubCategoryService {
  url = `${environment.apiUrl}`;
  constructor(private http: HttpClient) { }

  getCceSubCategories(cceCategoryId: number) {
    return this.http.get(`${this.url}AssessmentAndGrades/GetAllCceSubCategories/` + cceCategoryId);
  }
  insertCCESubCategory(item: CCESubCategory) {
    return this.http.post(`${this.url}AssessmentAndGrades/CreateAssessmentCceSubCategory/`, item);
  }
  updateCCESubCategory(item: CCESubCategory) {
    return this.http.put(`${this.url}AssessmentAndGrades/UpdateAssessmentCCESubCategory/`, item);
  }




  removeCCESubCategory(cceSubCategoryId) {
    return this.http.delete(`${this.url}AssessmentAndGrades/DeleteAssessmentCCESubCategory/` + cceSubCategoryId);
  }
  


}
